import { Spin } from "antd";
import { FirmasEvaluacion } from "./features/Firmas/FirmasEvaluacion";
import { ModalFirmas } from "./features/Firmas/ModalFirmas";
import { DetalleRubrosEvaluacion } from "./features/Rubros/DetalleRubrosEvaluacion";
// import { AudioLlamada } from "./features/AudioLlamada/AudioLlamada";
import { useDetalleEvaluacion } from "./hooks/useDetalleEvaluacion";
import { Calificacion } from "./shared/Calificacion";
import { EvaluacionesLayout } from "./shared/EvaluacionesLayout";
import { ResumenEvaluacion } from "./shared/ResumenEvaluacion";
import { fechaHoraVisible } from "./shared/evaluacionesUtils";
import styles from "./shared/Evaluaciones.module.css";

export function DetalleEvaluacionPage() {
  const {
    evaluacionId, evaluacion, cargando, error, volver,
    firmante, guardandoFirma, abrirFirma, cerrarFirma, guardarFirma,
  } = useDetalleEvaluacion();

  return (
    <EvaluacionesLayout
      titulo={`Evaluación #${evaluacionId}`}
      subtitulo={evaluacion?.asistenciaID}
      volver={volver}
      accion={
        <div className={styles.headerActions}>
          {/* <Button icon={<PrinterOutlined />} onClick={() => window.print()}>Imprimir</Button> */}
          {/* <AudioLlamada key={evaluacionId} duracion={evaluacion?.duracion} /> */}
        </div>
      }
    >
      {cargando && <Spin />}
      {error && <p className={styles.error} role="alert">{error}</p>}
      {evaluacion && (
        <>
          <div className={styles.detailScore}>
            <div>
              <span className={styles.label}>CALIFICACIÓN FINAL</span>
              <Calificacion value={evaluacion.calificacion} />
            </div>
          </div>
          <ResumenEvaluacion
            items={[
              ["Servicio", evaluacion.asistenciaID],
              ["ID empleado", evaluacion.usuarioEmpleadoID],
              ["Registro", evaluacion.id],
              ["Fecha de evaluación", fechaHoraVisible(evaluacion.fechaEvaluacion)],
            ]}
          />
          <div className={styles.serviceMeta}>
            <span>DURACIÓN {evaluacion.duracion}</span>
            <span>ETIQUETA {evaluacion.etiquetaLlamada}</span>
            <span>MONITOREO {evaluacion.tipoMonitoreo}</span>
          </div>
          <ResumenEvaluacion
            items={[
              ["ID supervisor", evaluacion.usuarioSupervisorID],
              ["Fecha supervisor", fechaHoraVisible(evaluacion.fechaUsuarioSupervisor)],
              ["ID analista", evaluacion.usuarioAnalistaID],
              ["Fecha analista", fechaHoraVisible(evaluacion.fechaUsuarioAnalistaCalidad)],
            ]}
          />
          <DetalleRubrosEvaluacion rubros={evaluacion.rubros} />
          <FirmasEvaluacion evaluacion={evaluacion} onFirmar={abrirFirma} />
        </>
      )}
      {firmante && (
        <ModalFirmas
          key={firmante.campo}
          firmante={firmante}
          guardando={guardandoFirma}
          onCerrar={cerrarFirma}
          onGuardar={guardarFirma}
        />
      )}
    </EvaluacionesLayout>
  );
}
